import { useQuery, useMutation } from '@tanstack/react-query';

import { restClient, serviceClient } from 'src/lib/api';

export const useLogin = () => {
  const mutationFn = (payload) =>
    restClient.post('/loginV2', payload).then((response) => response?.data);
  return useMutation({
    mutationFn,
    onSuccess: () => {},
  });
};

export const useOTP = () => {
  const mutationFn = (payload) =>
    restClient.post('/loginOtpValidation2', payload).then((response) => response?.data);
  return useMutation({
    mutationFn,
    onSuccess: () => {},
  });
};

export const useResendOTP = () => {
  const mutationFn = (payload) => restClient.post('/resendLoginOtp', payload);
  return useMutation({
    mutationFn,
    onSuccess: () => {},
  });
};

export const useVersionNumber = () => {
  const query = useQuery({
    queryKey: ['getVersionNumber'], // include param in key
    queryFn: () => serviceClient.get('getVersionNumber', {}),
    // enabled:false, // prevent auto-run if userId is undefined
  });

  return query;
};
